import Cookies from 'js-cookie';

// Invoke `fetch`, automatically populating the X-CSRF-Token header, which is requised for non-GET requests
export function fetchWithCsrf(
  input: RequestInfo,
  init?: RequestInit | undefined,
): Promise<Response> {
  if (!init) return fetch(input);
  const { headers, ...initRest } = init;

  // A meta tag exists with the CSRF token in the content attribute
  const csrfToken =
    (typeof document !== 'undefined'
      ? document.querySelector<HTMLMetaElement>("[name='csrf-token']")?.content
      : undefined) ?? Cookies.get('masked_csrf_token');
  if (!csrfToken) {
    return Promise.reject('CSRF token could not be found');
  }

  return fetch(input, {
    headers: {
      'X-CSRF-Token': csrfToken,
      ...headers,
    },
    ...initRest,
  });
}

export default fetchWithCsrf;
